<ng-container *ngIf="!showCard">
  <div class="no-record-inline">
    <div class="no-record-content">
      <div class="no-record-icon-wrap">
        <i class="fa fas" [ngClass]="icon" aria-hidden="true"></i>
      </div>
      <p class="no-record-message">{{ (customMessage ? (customMessage | translate) : null) || ('message.error.there-is-no-record' | translate) }}</p>
      <button *ngIf="buttonText" type="button" class="btn btn-primary mt-3" (click)="buttonPressed.emit()">
        {{ buttonText }}
      </button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="showCard">
  <div class="no-record-card" [style.max-width.px]="customWidth ? parseInt(customWidth, 10) : 300">
    <div class="no-record-content">
      <div class="no-record-icon-wrap">
        <i class="fa fas" [ngClass]="icon" aria-hidden="true"></i>
      </div>
      <p class="no-record-message">{{ (customMessage ? (customMessage | translate) : null) || ('message.error.there-is-no-record' | translate) }}</p>
      <button *ngIf="buttonText" type="button" class="btn btn-primary mt-3" (click)="buttonPressed.emit()">
        {{ buttonText }}
      </button>
    </div>
  </div>
</ng-container>